<template>
    <div>
        <OnboardingPage v-if="step === 1" @mandateTypeSelected="handleMandateTypeSelected" />
        <OnboardingCompanyPage
            v-if="step === 2"
            :selectedMandateType="selectedMandateType"
            @companySelected="handleCompanySelected"
        />
        <OnboardingElectronicAddressPage
            v-if="step === 3"
            :siren="company.siren.value"
            @addressSelected="handleAddressSelected"
        />
        <OnboardingLegalRepresentativePage
            v-if="step === 4"
            @validate="handleLegalRepresentativeValidation"
        />
    </div>
</template>
<script>
import OnboardingPage from 'vcomponents/pa/mandate/Onboarding/OnboardingPage.vue';
import OnboardingCompanyPage from 'vcomponents/pa/mandate/Onboarding/OnboardingCompanyPage.vue';
import OnboardingElectronicAddressPage from 'vcomponents/pa/mandate/Onboarding/OnboardingElectronicAddressPage.vue';
import OnboardingLegalRepresentativePage from 'vcomponents/pa/mandate/Onboarding/OnboardingLegalRepresentativePage.vue';

export default {
    components: {
        OnboardingPage,
        OnboardingCompanyPage,
        OnboardingElectronicAddressPage,
        OnboardingLegalRepresentativePage,
    },
    data() {
        return {
            step: 1,
            selectedMandateType: null,
            company: null,
            legalRepresentative: null,
        };
    },
    methods: {
        handleMandateTypeSelected(mandateType) {
            this.selectedMandateType = mandateType;
            this.step = 2;
        },
        handleCompanySelected(data) {
            this.company = data.company[0];
            this.legalRepresentative = data.legalRepresentative;
            this.step = this.selectedMandateType === 'receipt' ? 3 : 4;
        },
        handleAddressSelected(address) {
            this.company.electronicAddress = address;
            this.step = 4;
        },
        handleLegalRepresentativeValidation(data) {
            this.legalRepresentative = {
                ...this.legalRepresentative,
                ...data,
            };
        },
    },
};
</script>
